module.exports = __webpack_public_path__ + "static/auth-6d0b5564868bfcbf8e632d18f377599c.png";